import { render, staticRenderFns } from "./Tendency_singo.vue?vue&type=template&id=bd33f24c&scoped=true"
import script from "./Tendency_singo.vue?vue&type=script&lang=js"
export * from "./Tendency_singo.vue?vue&type=script&lang=js"
import style0 from "./Tendency_singo.vue?vue&type=style&index=0&id=bd33f24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd33f24c",
  null
  
)

export default component.exports